const formatGeoStratumsLeaf = (versionId, stratums) => {
    const result = [];

    for (const stratum of stratums) {
        const { stratumId, stratumTitle } = stratum;
        const key = `${versionId}-${stratumId}`;

        const leaf = {
            title: stratumTitle,
            key,
        };

        result.push(leaf);
    }

    return result;
};

/*
    Нормализация данных для последующей отрисовки в виде дерева
*/
export const normalizeData = data => {
    const result = [];
    const versions = Object.values(data);

    for (const version of versions) {
        const { versionTitle, versionId, geoStratums, ...other } = version;

        const stratums = Object.values(geoStratums);

        const node = Object.assign(
            {
                title: versionTitle,
                key: `${versionId}`,
                children: formatGeoStratumsLeaf(versionId, stratums),
            },
            other
        );

        result.push(node);
    }

    return result;
};
